import { CxEvent } from '@spartacus/core';

export class Ga4GgProductManualDownloadEvent extends CxEvent {
  event?: string;
  currency?: string;
  value?: number;
  click_text?: string;
  file_name?: string;
  visitor_type?: string;
  items?: {
    item_id?: string;
    item_name?: string;
    price?: number;
  }[];
}
